export const SUPPORTED_LANGUAGES = ['en', 'de', 'ru', 'it', 'bg', 'fi', 'pt']

export const LANGUAGE_INFO = [
  {
    'key': 'de',
    'flagCode': 'de',
    'translatedLang': 'Deutsch'
  },
  {
    'key': 'en',
    'flagCode': 'us',
    'translatedLang': 'English'
  },
  {
    'key': 'ru',
    'flagCode': 'ru',
    'translatedLang': 'Русский'
  },
  {
    'key': 'it',
    'flagCode': 'it',
    'translatedLang': 'Italiano'
  },
  {
    'key': 'bg',
    'flagCode': 'bg',
    'translatedLang': 'български'
  },
  {
    'key': 'fi',
    'flagCode': 'fi',
    'translatedLang': 'Suomeksi'
  },
  {
    'key': 'pt',
    'flagCode': 'pt',
    'translatedLang': 'Português'
  }
]
